<template>
  <div class="progress-fill" :style="progressWidth" />
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true
    }
  },

  computed: {
    progressWidth () {
      return { width: `${100 * this.progress}%` }
    }
  }
}
</script>
